// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"015426a6","267":"568dc35b","355":"99cd2152","415":"d27579b1","787":"393238a3","957":"0bc116ac"}[chunkId] + ".chunk.js";
};